export default "/assets/images/mila-feed-06.mp4?6cb13f301d9fbe23a4a70af459d59b2e";